import api from 'Application/api/api';

const createDriverLicenseControl = (data, cancelToken = null) =>
    api.post('/measures/vehicles/driver-licenses/controls', data, {
        cancelToken,
    });

export default createDriverLicenseControl;
